/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import { InjectionToken } from '@angular/core';

export const ITEM_ID_TOKEN = new InjectionToken<string>('itemId');
